import { registerTour } from '@/features/tours';
import { FEATURE_FLAGS } from '@/features/featureFlags';
import {
  activityStep,
  closeStep,
  filePickerStep,
  markupFilterStep,
  pageNavStep,
  revisionPickerStep,
  searchStep,
  shapesStep,
} from './steps';

export const DRAWINGS_EDITOR_TOUR_ID = 'drawings.editor';

registerTour({
  id: DRAWINGS_EDITOR_TOUR_ID,
  name: 'Drawing Editor',
  version: 1,
  featureFlagKey: FEATURE_FLAGS.DRAWINGS.id,
  steps: [
    {
      id: 'welcome',
      title: 'The Drawing Editor',
      body:
        'You\u2019ve opened a drawing. Here\u2019s a quick tour of the ' +
        'controls — switch sheets, mark up, search text, compare revisions.',
    },
    filePickerStep,
    revisionPickerStep,
    pageNavStep,
    shapesStep,
    markupFilterStep,
    activityStep,
    searchStep,
    closeStep,
  ],
});
